import { getLink } from "../../../../utils/utils";

import translator from "./translator";

const content = {
  esp: (
    `
    <div class="poem">
      <p class="poem-block mb-3">
        Tiu fajro ne povos sekigi vin – <br/>
        Ĉu granda, ĉu eta ĝi. <br/>
        Eĉ guton da akv’ ne varmigos ĝi – <br/>
        Ĉu granda, ĉu eta ĝi. <br/>
        Sed ŝvebas ĝi en ĉiela senlim’ <br/>
        Kaj glitas sur ondoj en marmalproksim’. <br/>
        La homoj nomas ĝin simple am’, <br/>
        Nomas ĉiuj el ni.
      </p>

      <p class="poem-block mb-3">
        La pluv’ ne estingos  fajregon ĉi, <br/>
        Ĝin ne forblovos vent’. <br/>
        Sed povas ja mem malaperi ĝi <br/>
        En ĉiu ajna moment’. <br/>
        Eble, ne fajro, sed stela rebril’, <br/>
        Eble, danĝera kaj pika scintil’. <br/>
        La homoj nomas ĝin simple am’. <br/>
        Singardu kun tiu sent’.
      </p>

      <p class="poem-block mb-3">
        La amo glitu sur onda abism’, <br/>
        Ne dronu en ŝtorma mar’. <br/>
        La amo ŝvebu sub firmament’ – <br/>
        Ne estu por vi la bar’. <br/>
        Kvankam nenion mi volas de vi, <br/>
        Mi same nenion bezonas sen vi… <br/>
        Do, lumu, fajreto, en tag’ kaj nokt’, <br/>
        Dum flugas la taga ar’…
      </p>
    </div>
    `
  )
}

const itemName = {
  esp: 'Amo'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemVideo: ['oVQQULakxz4&start=1695&end=1800'],
    itemTranslator: translator.esp
  }
}

export default item;